import { Icon } from '@chakra-ui/react';

export const CommentsIcon = (props: any) => (
  <Icon aria-label="comments icon" viewBox="4 4 16 16" {...props}>
    <path
      d="m6.05128205 5h11.48717945c1.3594702 0 2.4615385 1.09325817 2.4615385 2.44186047v3.66279073 4.3604651c0 1.3486023-1.1020683 2.0930232-2.4615385 2.0930232h-4.9206905c-1.6426166 0-2.4639248.8139535-2.4639248 2.4418605-1.64102569 0-2.46153851-.8139535-2.46153851-2.4418605h-1.23076923c-1.35947015 0-2.46153846-.7444209-2.46153846-2.0930232v-8.43023258c0-1.12383525.91839026-2.03488372 2.05128205-2.03488372z"
      fill="currentColor"
    />
  </Icon>
);
